import { useParams } from 'react-router-dom';
import { NotificationDetail } from '../components/notifications/NotificationDetail';

export function NotificationDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Invalid notification ID</div>;
  }

  return <NotificationDetail id={id} />;
}
